// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Tuh4vT4M","wrap":"MdpHvSq7","container":"KfI5EHNn"};